import React, { useEffect, useState } from "react";
import axios from "axios";
import { ApiEndpoints } from "../../services/ApiConstants";

function Sidebar() {
    const [teams, setTeams] = useState([]);

    useEffect(() => {
        const fetchTeams = () => {
            axios.get(`${ApiEndpoints.BASE_URL}${ApiEndpoints.GET_TEAMS}?page=0&size=80`)
                .then((res) => {
                    if (res.data && res.data.teams) {
                        const filtered = res.data.teams
                            .filter(t => t.teamId >= 2001 && t.teamId <= 2020)
                            .sort((a, b) => b.winCount - a.winCount);
                        setTeams(filtered);
                    }
                })
                .catch((err) => console.log("Teams error:", err));
        };
        fetchTeams();
        const interval = setInterval(fetchTeams, 30000);
        return () => clearInterval(interval);
    }, []);

    const getPoints = (team) => (team.winCount * 2) + team.drawCount;

    return (
        <div className="sidebar">
            <div className="sbox">
                <div className="sbox-h">AI IPL Standings</div>
                <table className="stand-t">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th style={{ textAlign: "left" }}>Team</th>
                        <th>W</th>
                        <th>Pts</th>
                    </tr>
                    </thead>
                    <tbody>
                    {teams.map((team, index) => (
                        <tr key={team.teamId}>
                            <td className={`rk ${index === 0 ? "r1" : ""}`}>{index + 1}</td>
                            <td>
                                <div className="tc">
                                    {team.teamPictureURL ? (
                                        <img src={team.teamPictureURL} alt={team.name}
                                             style={{ width: "20px", height: "20px", objectFit: "contain" }}
                                             onError={(e) => { e.target.style.display = 'none'; }} />
                                    ) : <div className="team-mini-logo">🏏</div>}
                                    {team.name}
                                </div>
                            </td>
                            <td style={{ color: index < 3 ? "var(--lime)" : "" }}>{team.winCount}</td>
                            <td className={`pts-v ${index === 9 ? "z" : ""}`}>{getPoints(team)}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <div className="sbox">
                <div className="sbox-h">Top Scorers Today</div>
                <div style={{ padding: "20px", color: "var(--text2)", textAlign: "center" }}>
                    🚧 Under Development
                </div>
            </div>

            <div className="sbox">
                <div className="sbox-h">Today's Session</div>
                <div style={{ padding: "20px", color: "var(--text2)", textAlign: "center" }}>
                    🚧 Under Development
                </div>
            </div>
        </div>
    );
}

export default Sidebar;